import { IAppState } from "../state";

export const condominiosSelector = (appState: IAppState) => appState.condominios.condominios;
export const condominioSelecionadoSeletor = (appState: IAppState) => appState.condominios.selecionado;